import { render, staticRenderFns } from "./VNotificationCard.vue?vue&type=template&id=223f781e"
import script from "./VNotificationCard.vue?vue&type=script&lang=js"
export * from "./VNotificationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports